<template>
  <de-layout-content>
    <div class="quesDetail">
      <!-- 主表单 -->
      <div class="topControl">
        <el-button size="" plain type="primary" @click="cancelQuesTemp">返回</el-button>
        <el-button type="primary" @click="saveScreenshot(1)" :disabled="disabled">保存</el-button>
        <el-button type="primary" @click="saveScreenshot(2)" :disabled="disabled"
          v-if="quesDetail.isPull == 1">保存并发布</el-button>
      </div>
      <div class="quesMain" id="quesMain">

        <el-form ref="quesDetail" :rules="queTemplateRules" :model="quesDetail" label-width="120px"
          class="formQuesDetail" label-position="top">
          <el-form-item label="问卷类型" prop="queType" v-if="enter == 1">
            <div class="typeLine">
              <el-select v-model:value="quesDetail.queType" placeholder="请选择问卷类型" clearable>
                <el-option v-for="(item, index) in queTypeArr" :key="index" :label="item.name" :value="item.id" />
              </el-select>
              <div class="typeMesgBtn" @click="typeMsgBtn">类型管理</div>
            </div>
          </el-form-item>
          <el-form-item label="问卷标题" prop="templateName" v-if="enter == 1">
            <el-input v-model="quesDetail.templateName" placeholder="输入问卷标题"></el-input>
          </el-form-item>
          <el-form-item label="模板标题" prop="templateName" v-else>
            <el-input v-model="quesDetail.templateName" placeholder="输入模板标题"></el-input>
          </el-form-item>
          <el-form-item label="指导说明" prop="explainInfo">
            <el-input type="textarea" rows="3" placeholder="输入指导说明" v-model="quesDetail.explainInfo" maxlength="100"
              show-word-limit></el-input>
          </el-form-item>
          <div class="question_lists" v-if="questionList && questionList.length > 0">
            <Topic :selectItemS="selectItemS" :topicData="questionList" :editeSut="editeSut" @showModal="showModal"
              @delModal="delModal" @change="change" />
          </div>
        </el-form>

        <!-- 新增问题按钮 -->
        <a-form-item class="addWtButton">
          <a-button type="primary" @click="showModal(1)">
            <i class="el-icon-circle-plus-outline" style="margin-right: 5px;"></i>新建问题
          </a-button>
        </a-form-item>

        <!-- 新建问题-element-start -->
        <el-dialog :title="modalTitle" :visible.sync="show" width="600px" :before-close="queTypeClose"
          custom-class="queTemplateDialog">
          <el-form ref="editForm" :model="editForm" label-width="100px" class="editFormModal">
            <el-form-item label="问题" prop="topicName" :rules="{ required: true, message: '请输入问题标题', trigger: 'blur' }">
              <el-input v-model="editForm.topicName" placeholder="请输入问题" clearable></el-input>
            </el-form-item>
            <el-form-item label="问题题型" prop="topicType"
              :rules="{ required: true, message: '请选择问题题型', trigger: 'change' }">
              <el-select v-model="editForm.topicType" placeholder="请选择问题题型" clearable @change="changeTopicType">
                <el-option label="拉条" :value="1" />
                <el-option label="单选" :value="2" />
                <el-option label="多选" :value="3" />
                <el-option label="人体图" :value="4" />
              </el-select>
            </el-form-item>
            <div v-if="[1].includes(editForm.topicType)">
              <el-form-item label="拉条选项" v-for="(item, index) in braceArr"
                :prop="`remark_${index + 1}`" :rules="{ required: true, message: '请输入拉条内容', trigger: 'blur' }">
                <div class="flex-b-c answerLine">
                  <div class="mathBorder">{{ index + 1 }}</div>
                  <el-input v-model="editForm[`remark_${item + 1}`]" :placeholder="`说明_${index + 1}`"
                    clearable></el-input>
                  <div class="closeOdd" @click="delBrace(item)" v-if="braceArr.length > 2">
                    <i class="el-icon-circle-close"></i>
                  </div>
                </div>
              </el-form-item>
              <div class="txt-center newAddBtn">
                <div v-if="quations.length < 26">
                  <i class="el-icon-circle-plus-outline" @click="addBrace"></i>
                </div>
              </div>
            </div>

            <div v-else-if="[2, 3].includes(editForm.topicType)">
              <el-form-item label="答案选项" v-for="(item, index) in quations"
                :prop="`quation_${index + 1}`" :rules="{ required: true, message: '请输入选项内容', trigger: 'blur' }">
                <div class="flex-b-c answerLine">
                  <div class="mathBorder">{{ index + 1 }}</div>
                  <el-input v-model="editForm[`quation_${item + 1}`]" :placeholder="`选项_${index + 1}`"></el-input>
                  <div @click="delQuation(item)" v-if="quations.length > 2">
                    <i class="el-icon-circle-close"></i>
                  </div>
                </div>
              </el-form-item>
              <div class="txt-center newAddBtn">
                <div v-if="quations.length < 26">
                  <i class="el-icon-circle-plus-outline" @click="addQuation"></i>
                </div>
              </div>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer dialogBoredTop">
            <el-button @click="cancel('editForm')">取 消</el-button>
            <el-button type="primary" @click="confirm('editForm')">保 存</el-button>
          </div>
        </el-dialog>
        <!-- 新建问题-element-end -->
      </div>
    </div>

    <!-- 新建问卷类型 -->
    <el-dialog title="新建问卷类型" :visible.sync="queTypeDialog" width="600px" :before-close="queTypeClose"
      custom-class="queTemplateDialog">
      <el-form ref="queTypeForm" :model="queTypeForm" :rules="tempTypeRules" label-width="110px">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="queTypeForm.name" placeholder="请输入类型名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="关联档案分类" prop="type">
          <el-select v-model="queTypeForm.type" placeholder="请选择关联档案分类" clearable>
            <el-option v-for="(item, index) in archivesClassArr" :key="index" :label="item.name" :value="item.name" >
              </el-option>
          </el-select>
          <div class="newLine">如需在某个分类下展示，则需要选择分类；如不关联分类展示，则不需要选择</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer dialogBoredTop">
        <el-button @click="queTypeDialog = false">取 消</el-button>
        <el-button type="primary" @click="queTypeSave">保 存</el-button>
      </div>
    </el-dialog>
  </de-layout-content>
</template>

<script>
import moment from "moment";
import Vue from 'vue';
import Topic from '../../workBench/components/Topic.vue';
import html2canvas from 'html2canvas';
import axios from 'axios'
import * as API_Ques from "@/api/dataAccess/questionnaire";
import { message } from "ant-design-vue";
let Num = 1;
export default {
  components: {
    Topic
  },
  data() {
    return {
      id: this.$route.query.id,
      enter: this.$route.query.enter,
      modalTitle: "新建问题",
      disabled: false,
      queTemplateRules: {
        queType: [
          { required: true, message: '请选择问卷类型', trigger: 'change' },
        ],
        templateName: [
          { required: true, message: '请输入问卷标题', trigger: 'blur' },
        ]
      },

      // 类型管理-start
      queTypeDialog: false,
      queTypeForm: {
        name: '',
        queType: '',
      },
      tempTypeRules: {
        name: [
          { required: true, message: '请输入类型名称', trigger: 'blur' },
        ],
      },
      archivesClassArr: [],
      // 类型管理-end

      selectItemS: {},
      questionList: [],
      quations: [0, 1],
      braceArr: [0, 1],
      show: false,
      quesDetail: {
        queType: '',
        templateName: '',
        explainInfo: ''
      },
      questionType: [
        {
          name: '拉条',
          value: 1
        },
        {
          name: '单选',
          value: 2
        },
        {
          name: '多选',
          value: 3
        },
        {
          name: '人体图',
          value: 4
        }
      ],
      rules: {
        minFakeTime: [{
          required: true,
          message: "请输入时间最小值",
          trigger: "blur"
        },],
        maxFakeTime: [{
          required: true,
          message: "请输入时间最大值",
          trigger: "change"
        },],
        minFakeNum: [{
          required: true,
          message: "请输入最小票数",
          trigger: "change"
        },],
        maxFakeNum: [{
          required: true,
          message: "请输入最大票数",
          trigger: "blur"
        },],
        isEnable: [{
          required: true,
          message: "请选择启用状态",
          trigger: "change",
        }],
        voteFakeStatus: [{
          required: true,
          message: "请选择启用状态",
          trigger: "change",
        }],
        refuseSelect: [{
          required: true,
          message: "请选择拒绝原因",
          trigger: "change",
        }],

      },

      editForm: {
        id: null,
        topicName: null,
        topicType: null,
        sortSeq: null,
        quation_1: null,
        quation_2: null,
        remark_1: '',
        remark_2: '',
        optionVos: [],
        slider_marks: {},
        topicOption: [],
        sliderMaxVal: 0
      },
      newEditForm: {
        id: null,
        topicName: null,
        topicType: null,
        sortSeq: null,
        quation_1: null,
        quation_2: null,
        remark_1: '',
        remark_2: '',
        optionVos: [],
        slider_marks: {},
        topicOption: [],
        sliderMaxVal: 0
      },
      dataSource: [],
      //数据分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
      },
      editeTemplateQueList: [],
      quesSut: null, //判断是编辑还是新增
      base64: '',
      imgUrl: '',
      editeSut: true,
      queTypeArr: []
    };
  },
  created() {
    this.getQueTypeArr()
    if (this.id) {
      console.log('编辑进来')
      this.getEditDetail()
      this.quesSut = 2
    } else {
      console.log('新增进来')
      this.quesSut = 1
    }
  },
  mounted() {

  },
  methods: {

    // 新建问卷类型-保存
    queTypeSave() {
      this.$refs["queTypeForm"].validate((valid) => {
        if (valid) {
          const params = {
            name: this.queTypeForm.name,
            type: this.queTypeForm.type
          }
          this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          API_Ques.addQueType(params).then(res => {
            if (res.code == 200) {
              this.queTypeDialog = false
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.getQueTypeArr()
              this.loading.close()
            }
          })
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },

    // 新建问卷类型-end

    // 获取问卷类型
    getQueTypeArr() {
      API_Ques.getQueTypeList().then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.queTypeArr = res.data
            this.queTypeArr.forEach((ele, i) => {
              ele.label = ele.name
              ele.value = ele.id
            });
          } else {
            this.queTypeArr = []
          }
          // this.queTypeArr = res.data.length > 0 ? res.data : []
        }
      })
    },

    // 选择问题题型{
    changeTopicType(e) {
      // this.editForm.topicType = e
      Vue.set(this.editForm, 'topicType', e)
    },

    // html2canvas截图
    saveScreenshot(e) {
      this.$refs["quesDetail"].validate((valid) => {
        if (valid) {
          this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.disabled = true
          const element = document.getElementById('quesMain'); // 指定需要截图的元素ID或选择器
          element.style.maxHeight = '1000px';
          html2canvas(element).then((canvas) => {
            const screenshotUrl = canvas.toDataURL('image/jpeg', 0.6); // 获取截图的Base64编码字符串
            // 将screenshotUrl传递到服务器或本地处理等操作
            this.base64 = screenshotUrl
            API_Ques.uploadOssBase64(screenshotUrl).then(res => {
              if (res.code == 200) {
                this.imgUrl = res.data.url
                this.saveConfirm(e)
              }
            })
          });
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      })
    },

    // 新建问卷类型-start
    typeMsgBtn() {
      this.getByKey()
      this.queTypeForm = {
        name: '',
        type: ''
      }
      this.queTypeDialog = true
    },

    // 获取关联档案分类
    getByKey() {
      const params = {
        key: 'QUE_TYPE_INFO',
      };
      API_Ques.sportsGetByKey(params).then(res => {
        if (res.code == 200) {
          const jsonData = JSON.parse(decodeURIComponent(res.data))
          this.archivesClassArr = jsonData.length > 0 ? jsonData : []
        }
      })
    },


    // 编辑进来获取展示数据
    getEditDetail() {
      let url = this.enter == 1 ? 'getQueInfo' : 'getQueTemplateInfo'
      API_Ques[url]({ 'id': this.id }, false, true).then(res => {

        this.quesDetail = res.data
        this.quesDetail.queType = res.data.queTypeId
        if (res.data.listl) {
          res.data.listl.map(item => {
            item.answer = Array.isArray(item.answers) ? item.answers[0].answerId : item.answer ? item.answer : ''
            item.disabled = false
          })

          this.questionList = res.data.listl
          this.questionList.forEach((ele, i) => {
            if (ele.topicType == 1) {
              ele.slider_marks = {}
              ele.sliderMaxVal = null
              ele.optionVos.forEach((element, index) => {
                ele.slider_marks[index + 1] = element.remark
                ele.sliderMaxVal = index + 1
              })
            }
          });
          this.selectItemS = res.data.listl.filter(item => item.topicType === 4)
        }
      })
    },

    // 新增单选复选答案选项
    addQuation() {
      this.quations.push(++Num);
    },

    // 删除单选和复选答案选项
    delQuation(item) {
      const index = this.quations.findIndex((i) => i == item);
      this.quations.splice(index, 1);
      delete this.editForm['quation_' + (item + 1)]
    },

    // 新增横条答案选项
    addBrace() {
      this.braceArr.push(++Num);
    },

    // 删除横条答案选项
    delBrace(item) {
      const index = this.braceArr.findIndex((i) => i == item);
      this.braceArr.splice(index, 1);
      delete this.editForm['remark_' + (item + 1)]
    },

    // 返回上一级
    cancelQuesTemp() {
      this.$router.back()
    },

    // 新增单个问题确认
    confirm(formName) {
      this.$refs[formName]
        .validate()
        .then(() => {
          this.parseEdit = JSON.parse(JSON.stringify(this.editForm))
          let topicOption = []
          if (this.parseEdit.topicType === 1) {
            // 横条字段格式化
            const remarkkeys = Object.keys(this.parseEdit).filter(
              (i) => i.includes("remark_") && this.parseEdit[i]
            );
            topicOption = remarkkeys.map((item, index) => {
              return {
                brace: index + 1,
                remark: this.parseEdit[item],
              };
            });
          } else if (this.parseEdit.topicType === 2 || this.parseEdit.topicType === 3) {
            // 单选和多选字段格式化
            const optionkeys = Object.keys(this.parseEdit).filter(
              (i) => i.includes("quation_") && this.parseEdit[i]
            );
            // 问题选项
            topicOption = optionkeys.map((item, index) => {
              return {
                answerId: String.fromCharCode(index + 65),
                option: this.parseEdit[item],
              };
            });
          }

          // 请求接口保存单个问题-start
          // this.id有值就是编辑状态
          const params = {
            topicName: this.parseEdit.topicName,
            topicType: this.parseEdit.topicType,
            topicOption: JSON.stringify(topicOption),
          };

          const url = this.parseEdit.id ? 'queEditQueBank' : 'queAddQueBank'
          if (this.parseEdit.id) {
            params.id = this.parseEdit.id
          } else {
            delete params.id
          }

          API_Ques[url](params).then(res => {
            this.cancel(); // 清空表单
            this.show = false;
            console.log('走111')
            if (res.data) {
              console.log('走222')
              if (topicOption) {
                console.log('走333')
                this.parseEdit.optionVos = topicOption
              }
              if (res.data === true) {
                console.log('走444')
                if (this.parseEdit.topicType != 1) {
                  this.questionList.forEach(ele => {
                    if (ele.id === this.parseEdit.id) {
                      console.log('走555')
                      ele.topicName = this.parseEdit.topicName
                      ele.topicType = this.parseEdit.topicType
                      ele.optionVos = this.parseEdit.optionVos
                      ele.topicOption = JSON.stringify(topicOption)
                    }
                  })
                } else {
                  console.log('走777')
                  this.questionList.forEach((ele, i) => {
                    if (ele.id === this.parseEdit.id) {
                      console.log('走888')
                      ele.topicName = this.parseEdit.topicName
                      ele.topicType = this.parseEdit.topicType
                      ele.optionVos = this.parseEdit.optionVos
                      ele.topicOption = JSON.stringify(topicOption)
                      console.log("88-1")

                      ele.slider_marks = {}
                      ele.sliderMaxVal = 0
                      ele.optionVos.forEach((element, index) => {
                        console.log('走999')
                        ele.slider_marks[index + 1] = element.remark
                        ele.sliderMaxVal = this.parseEdit.optionVos.length
                      })
                      setTimeout(() => {
                        this.$set(this.questionList, 'key', new Date().getTime())
                      }, 500);
                      console.log('questionListquestionListquestionList')
                    }
                  });
                }
              } else {
                console.log('走666')
                this.parseEdit.id = res.data
                this.parseEdit.topicOption = JSON.stringify(topicOption)
                this.parseEdit.slider_marks = {}
                this.parseEdit.sliderMaxVal = 0
                this.parseEdit.optionVos.forEach((element, index) => {
                  console.log('走999')
                  this.parseEdit.slider_marks[index + 1] = element.remark
                  this.parseEdit.sliderMaxVal = this.parseEdit.optionVos.length
                })
                this.questionList.push(this.parseEdit)
              }
            }
          })
        })
    },

    cancel() {
      this.show = false
      Num = 1;
      this.braceArr = [0, 1];
      this.quations = [0, 1];
    },

    reset(form, otherReset) {
      let keys = otherReset ? Object.keys(otherReset) : [];
      for (let key in form) {
        if (keys.includes(key)) {
          form[key] = otherReset[key];
        } else {
          form[key] = null;
        }
      }
    },

    saveConfirm(e) {

      let postUrl = ''
      this.editeTemplateQueList = []
      this.questionList.forEach(ele => {
        this.editeTemplateQueList.push({
          queId: ele.id,
        })
      });
      let params = {
        'templateName': this.quesDetail.templateName,
        'explainInfo': this.quesDetail.explainInfo,
        'queType': this.quesDetail.queType,
        'isPull': 1,
        'isUse': 1,
        'templateImg': this.imgUrl
      }
      if (this.id) {
        params.id = this.id
      }
      if (this.enter == 1) {
        postUrl = 'saveQueManagement'
        params.templateQueSaveDTOList = this.editeTemplateQueList
        // params.queType = this.quesDetail.queType
      } else {
        postUrl = 'saveQueTemplate'
        params.templateQueManagementSaveDTOList = this.editeTemplateQueList
      }

      console.log('保存全部')
      API_Ques[postUrl](params, false, true).then(res => {
        if (res.code == 200) {
          console.log('判断保存并发布=====')

          this.loading.close()
          this.disabled = false

          if (e == 1) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            setTimeout(() => {
              this.$router.back()
            }, 500);
          } else {
            this.saveEndRelease()
          }

        } else {
          this.loading.close()
          this.disabled = false
        }
      })
    },

    // 保存后执行发布
    saveEndRelease() {
      const params = {
        id: this.id,
        ispull: 2
      };
      API_Ques.queManagementisPull(params).then(res => {
        if (res.code == 200) {
          this.$message.success("保存并发布成功");
          setTimeout(() => {
            this.$router.back()
          }, 500);
        }
      })
    },

    // 子传父-start
    showModal(e) {
      console.log('子传父')
      console.log(e)
      if (e != 1) {
        if (e.topicType) {
          const currentRow = JSON.parse(JSON.stringify(e));
          this.modalTitle = "编辑问题";
          this.editForm.id = e.id || '';
          this.editForm = currentRow;
          console.log('走这里了....')
          // 单选或者多选回显
          if ([1].includes(currentRow.topicType)) {
            const options = JSON.parse(currentRow.topicOption);
            options.forEach((item, index) => {
              this.$set(this.editForm, [`remark_${index + 1}`], item.remark);
            });
            this.braceArr = Array.from(
              {
                length: options.length,
              },
              (i, j) => {
                return j;
              }
            );
            Num = options.length - 1;
          } else if ([2, 3].includes(currentRow.topicType)) {
            const options = JSON.parse(currentRow.topicOption);
            options.forEach((item, index) => {
              this.$set(this.editForm, [`quation_${index + 1}`], item.option);
            });
            this.quations = Array.from(
              {
                length: options.length,
              },
              (i, j) => {
                return j;
              }
            );
            Num = options.length - 1;
            console.log('进了这里2')
          }
        } else {
          this.editForm = {}
          this.editForm = this.newEditForm
        }
      } else {
        console.log('新建')
        this.editForm = {}
        this.$set(this.editForm, JSON.parse(JSON.stringify(this.newEditForm)))
      }

      this.show = true;
    },

    // 移除单条问题传值
    delModal(e) {
      this.questionList.forEach((item, index) => {
        if (item.id == e.id) {
          this.questionList.splice(index, 1); // 移除元素
        }
      });
    },
    // 子传父-end

  },

};
</script>
<style lang='less' scoped>
/deep/ .queTypeLine .ant-form-item-children {
  display: flex;
  align-items: center;
}

.typeMesgBtn {
  color: #1890ff;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;

  &:hover {
    opacity: .5;
  }
}

.newLine {
  width: 100%;
  display: inline-block;
  font-size: 12px;
  color: #999;
  line-height: 22px;
  margin-top: 10px;
}

/deep/.quesDetail {
  padding: 20px 0;

  .topControl {
    display: flex;
    justify-content: right;

    button {
      margin-left: 20px;
    }
  }

  .quesMain {
    width: 800px;
    padding-bottom: 80px;
    background-color: #141937;
  }

  .addWtButton {
    text-align: center;
    margin-top: 30px;

    button {
      width: 200px;
      margin: 0 auto;
      border: 1px solid #1890FF;
      color: #1890FF;
      padding: 10px 0;
      height: auto;
      background-color: transparent;

      &:hover {
        background-color: #1890FF;
        color: #fff;
      }
    }
  }

  .el-form-item {
    .el-input {
      .el-input__inner {
        background-color: #282F54;
        border: 0;
        color: #fff;

        &::-webkit-input-placeholder {
          color: #999;
        }
      }
    }

    .el-textarea {
      .el-textarea__inner {
        background-color: #282F54;
        color: #fff;
        border: 0;

        &::-webkit-input-placeholder {
          color: #999;
        }
      }

      .el-input__count {
        background: #282F54;
        color: #999;
      }
    }
  }
}

.editFormModal {
  .ant-row {
    display: flex;
    align-items: center;
  }

  .newAddBtn {
    .el-icon-circle-plus-outline {
      font-size: 25px;
      color: #999;
      cursor: pointer;

      &:hover {
        color: #1890FF;
      }
    }
  }
}

/deep/ .editFormModal .ant-form-item-control-wrapper {
  flex: 1 !important;
  width: 100% !important;
}

.answerLine {
  display: flex;
  align-items: center;

  .math {
    margin-right: 5px;
    color:#ccc;
  }
  .mathBorder {
    margin-right: 5px;
    color:#ccc;
    height: 36px;
    width: 36px;
    display: flex;
    // box-sizing: border-box;
    border-radius: 3px;
    align-items: center;
    // margin-top: 2px;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, .1);
  }
  .el-input{
    flex: 1;
  }
  input {
    flex: 1;
  }

  .closeOdd {
    margin-top: 4px;
  }

  i.el-icon-circle-close {
    font-size: 20px;
    color: #aaa;
    margin-left: 10px;
    cursor: pointer;

    &:hover {
      color: #ff0;
    }
  }
}

/deep/ .formQuesDetail .typeLine {
  display: flex;
}

/deep/ .formQuesDetail .typeLine .el-select {
  width: 100%;
}

/deep/ .quesDetail {
  .el-form-item__label {
    color: #fff;
    font-weight: normal;
  }
}
</style>
